import React, { useState } from 'react';
import copy from 'copy-to-clipboard';

const Contact = () => {
    const [copied, setCopied] = useState(false);
    const email = 'carneson39@gmail.com';

    const copyEmail = () => {
        copy(email);
        setCopied(true);
        setTimeout(() => {setCopied(false)}, 2500);
    }
    
    return (
        <section id='contact'>
            <div className='contact-container'>
                <h3>Interested in connecting?</h3>
                <div className='email-button' onClick={copyEmail}>
                    <span>Email me <i className='fas fa-long-arrow-alt-right' /></span>
                </div>
                <p className={copied ? 'copy-success' : 'not-copied'}>My email was copied to your clipboard! <span role='img' aria-label='party emoji'>🎉</span></p>
            </div>
        </section>
    )
}

export default Contact;